import { ChangeDetectionStrategy, Component, OnDestroy, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject, take, takeUntil } from 'rxjs';
import { WishlistsFacade } from 'src/app/extensions/wishlists/facades/wishlists.facade';
import { Wishlist } from 'src/app/extensions/wishlists/models/wishlist/wishlist.model';

import { ProductContextDirective } from 'ish-core/directives/product-context.directive';
import { SkuQuantityType } from 'ish-core/models/product/product.model';
import { ModalDialogComponent } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';
import { ModalDialogComponent as ModalDialogComponent_1 } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';
import { ProductAddToBasketComponent } from 'ish-shared/components/product/product-add-to-basket/product-add-to-basket.component';

@Component({
  selector: 'custom-filter-wishlist',
  templateUrl: './custom-filter-wishlist.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    ProductAddToBasketComponent,
    ProductContextDirective,
    FaIconComponent,
    ModalDialogComponent_1,
    TranslateModule,
  ],
})
export class CustomFilterWishlistComponent implements OnDestroy {
  private wishListFacade = inject(WishlistsFacade);
  private translate = inject(TranslateService);

  readonly wishlists = input<Wishlist[]>(undefined);
  private destroy$ = new Subject<void>();
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  delete(wishListId: string) {
    this.wishListFacade.deleteWishlist(wishListId);
  }
  openDeleteConfirmationDialog(wishlist: Wishlist, modal: ModalDialogComponent<string>) {
    this.translate
      .get('account.wishlists.delete_wishlist_dialog.header', { 0: wishlist.title })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(res => (modal.options().titleText = res));

    modal.show(wishlist.id);
  }
  getParts(wishList: Wishlist): SkuQuantityType[] {
    return wishList?.items.map(item => ({ sku: item.sku, quantity: item.desiredQuantity.value }));
  }
}
